import React, { useState } from 'react';
import styles from './clientCreate.module.css';
import createClient from '../../../../api/clients/createClient';
import { useNavigate } from 'react-router-dom';

// components
import HookForm from '../../../../components/HookForm/HookForm';
import Datepicker from '../../../../components/Inputs/Datepicker/Datepicker';
import SelectPhoto from './SelectPhoto/SelectPhoto';
import Select from '../../../../components/Select/Select';
import SelectPhoneType from '../../../../components/Selects/SelectPhoneType';
import AddButton from '../../../../components/AddButton/AddButton';
import DeleteButton from '../../../../components/DeleteButton/DeleteButton';
import SelectAddressType from '../../../../components/Selects/SelectAddressType';
import SelectSocialType from '../../../../components/Selects/SelectSocialType';
import SelectClientType from '../../../../components/Selects/SelectClientType';
import SelectKato from '../../../../components/Selects/SelectKato';
import { shortFormsEnabled } from '../../../../brand/tenant';
import SelectCity from '../../../../components/Selects/SelectCity';
import Button from '../../../../components/Button/Button';
import Alert from '../../../../components/Alert/Alert';
import Loader from '../../../../components/Loader/Loader';

import { phone, iin } from '../../../../constants/mask';
import SelectClientID from '../../../../components/Selects/SelectClientD';
import SelectClientDocumentType from '../../../../components/Selects/SelectClientDocumentTypes';
import SelectClientIssuer from '../../../../components/Selects/SelectClientDocumentType';
import alert from '../../../../helpers/alert';
import historyObject from '../../../../utils/historyObject';
import verifyClient from '../../../../api/clients/verification';
import phoneBelongsIinValidate from '../../../../api/bmg/phoneBelongsIinValidate';
import { BMG_UNAVAILABLE_MESSAGE } from '../../../../utils/clientContact';
import getClients from '../../../../api/clients/getClients';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import toNameCase from '../../../../utils/toNameCase';

const formStyles = {
  mainData: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a ' 'b b b ' 'k k c' 'd d d'` },
  contacts: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  },
  document: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '20px',
  },
  comment: { display: 'grid', gap: '20px' },
};

const addFormInputs = (e, btn, form, setForm) => {
  e.preventDefault();
  e.stopPropagation();
  const btnIndex = form.map((inputs) => inputs.name).indexOf(btn);
  if (btn === 'addPhone') {
    form.splice(btnIndex, 0, {
      component: SelectPhoneType,
      name: `phoneType_${btnIndex}`,
      defaultValue: { value: 1, label: 'ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÐ¹' },
    });
    form.splice(btnIndex + 1, 0, {
      name: `phoneNumber_${btnIndex}`,
      label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
      placeholder: '+7(___) ___-__-__',
      mask: phone,
    });
    form.splice(btnIndex + 2, 0, {
      component: DeleteButton,
      name: `deleteBtn_${btnIndex}`,
      onClick: (e) =>
        deleteFormInputs(e, form.map((inputs) => inputs.name).indexOf(`deleteBtn_${btnIndex}`), form, setForm),
    });
    setForm([...form]);
  }
  if (btn === 'addAddress') {
    form.splice(btnIndex, 0, {
      component: SelectAddressType,
      name: `addressType_${btnIndex}`,
      defaultValue: { value: 1, label: 'ÐÐ¾Ð¼Ð°ÑÐ½Ð¸Ð¹' },
    });
    form.splice(btnIndex + 1, 0, {
      name: `address_${btnIndex}`,
      label: 'ÐÐ´ÑÐµÑ',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð°Ð´ÑÐµÑ',
    });
    form.splice(btnIndex + 2, 0, {
      component: DeleteButton,
      name: `deleteBtn_${btnIndex}`,
      style: { marginTop: 'auto' },
      onClick: (e) =>
        deleteFormInputs(e, form.map((inputs) => inputs.name).indexOf(`deleteBtn_${btnIndex}`), form, setForm),
    });
    setForm([...form]);
  }
  if (btn === 'addSocial') {
    form.splice(btnIndex, 0, {
      component: SelectSocialType,
      name: `socialType_${btnIndex}`,
      defaultValue: { value: 2, label: 'VK' },
    });
    form.splice(btnIndex + 1, 0, {
      name: `social_${btnIndex}`,
      label: 'URL',
      placeholder: 'ÑÑÑÐ»ÐºÐ°',
    });
    form.splice(btnIndex + 2, 0, {
      component: DeleteButton,
      name: `deleteBtn_${btnIndex}`,
      style: { marginTop: 'auto' },
      onClick: (e) =>
        deleteFormInputs(e, form.map((inputs) => inputs.name).indexOf(`deleteBtn_${btnIndex}`), form, setForm),
    });
    setForm([...form]);
  }
};

const deleteFormInputs = (e, inputsIndex, form, setForm) => {
  e.preventDefault();
  e.stopPropagation();
  form.splice(inputsIndex - 2, 3);
  setForm([...form]);
};

// onCreated Ð¿ÑÐµÐ²ÑÐ°ÑÐ°ÐµÑ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð² ÑÐ°Ð³ ÑÑÐ¶Ð¾Ð³Ð¾ ÑÐ»Ð¾Ñ (Ð¼Ð¾Ð´Ð°Ð»ÐºÐ° Â«ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°Â»):
// Ð²Ð¼ÐµÑÑÐ¾ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ° Ð½Ð°Ð·Ð°Ð´ Ð¾ÑÐ´Ð°ÑÐ¼ Ð½Ð°Ð²ÐµÑÑ id ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°.
const ClientCreate = ({
  onCreated,
  hidePhoto,
  hideKato = shortFormsEnabled(),
  hideLanguage = shortFormsEnabled(),
  hideContacts = shortFormsEnabled(),
}) => {
  const user = useSelector(state => state?.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [succes, setSucces] = useState({});
  const [photo, setPhoto] = useState();
  const [uploadPhoto, setUploadPhoto] = useState();
  const [mainData, setMainData] = useState([
    {
      name: 'surname',
      label: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ',
      placeholder: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
      transform: toNameCase,
      rules: {
        required: true,
      },
      capitalize: true,
    },
    {
      name: 'name',
      label: 'ÐÐ¼Ñ',
      placeholder: 'ÐÐ¼Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
      transform: toNameCase,
      rules: {
        required: true,
      },
      capitalize: true,
    },
    { name: 'middlename', label: 'ÐÑÑÐµÑÑÐ²Ð¾', placeholder: 'ÐÑÑÐµÑÑÐ²Ð¾ (ÐµÑÐ»Ð¸ ÐµÑÑÑ)', transform: toNameCase },
    {
      name: 'iin',
      label: 'ÐÐÐ',
      placeholder: '_ _ _ _ _ _ _ _ _ _ _',
      mask: iin,
      rules: {
        required: true,
      },
    },
    {
      component: Datepicker,
      name: 'born',
      label: 'ÐÐ°ÑÐ° ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ',
      placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³',
      rules: {
        required: true,
      },
    },
    // Ð¯Ð·ÑÐº Ð½ÑÐ¶ÐµÐ½ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð¼, Ð³Ð´Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÑ ÑÑÐ¾Ð´ÑÑ Ð¿Ð¸ÑÑÐ¼Ð° Ð¸ Ð·Ð°ÑÐ²ÐºÐ° Ð² Ð±Ð°Ð½Ðº.
    // ÐÑÐ¾Ð´Ð°Ð²ÑÑ ÐÐ£-Ð°Ð²ÑÐ¾ Ð½Ð¸ ÑÐ¾Ð³Ð¾, Ð½Ð¸ Ð´ÑÑÐ³Ð¾Ð³Ð¾ Ð½Ðµ ÑÐ»ÑÐ¼ â Ð¿Ð¾Ð»Ðµ Ð»Ð¸ÑÐ½ÐµÐµ.
    ...(hideLanguage
      ? []
      : [
          {
            component: Select,
            label: 'Ð¯Ð·ÑÐº',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            name: 'languageId',
            options: [
              { value: 1, label: 'ÐÐ°Ð·Ð°ÒÑÐ°' },
              { value: 2, label: 'Ð ÑÑÑÐºÐ¸Ð¹' },
            ],
            rules: {
              required: true,
            },
          },
        ]),
    {
      component: Select,
      label: 'ÐÐ¾Ð»',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      name: 'gender',
      options: [
        { value: 1, label: 'ÐÑÐ¶ÑÐ¸Ð½Ð°' },
        { value: 2, label: 'ÐÐµÐ½ÑÐ¸Ð½Ð°' },
      ],
      rules: {
        required: true,
      },
    },
    {
      name: 'phoneNumber',
      label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
      placeholder: '+7(___) ___-__-__',
      mask: phone,
      rules: {
        required: true,
      },
      style: { gridColumn: 3, gridRow: 2, },
    },
    // ÐÐÐ¢Ð ÑÐ¿ÑÐ°ÑÐ¸Ð²Ð°ÑÑ Ð±Ð°Ð½ÐºÐ¸ Ð¿Ð¾ Ð·Ð°ÑÐ¼ÑÐ¸ÐºÑ. ÐÑÐ¾Ð´Ð°Ð²ÐµÑ ÐºÑÐµÐ´Ð¸Ñ Ð½Ðµ Ð±ÐµÑÑÑ,
    // Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð² ÐµÐ³Ð¾ ÐºÐ°ÑÑÐ¾ÑÐºÐµ ÑÐµÐ³Ð¸Ð¾Ð½ Ð½Ðµ ÑÐ¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼.
    ...(hideKato
      ? []
      : [
          {
            component: SelectKato,
            name: 'kato',
            label: 'Ð ÐµÐ³Ð¸Ð¾Ð½ (ÐÐÐ¢Ð)',
            rules: {
              required: true,
            },
            style: { gridColumn: '1 / span 2', gridRow: 3 },
          },
        ]),
    {
      name: 'registration_street',
      label: 'Ð£Ð»Ð¸ÑÐ° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐ»Ð¸ÑÑ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸',
      rules: {
        required: true,
      },
    },
    {
      name: 'registration_house_number',
      label: 'ÐÐ¾Ð¼',
      placeholder: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð¼Ð°',
      rules: {
        required: true,
      },
    },
    {
      name: 'registration_apartment_number',
      label: 'ÐÐ²Ð°ÑÑÐ¸ÑÐ°',
      placeholder: 'ÐÐ¾Ð¼ÐµÑ ÐºÐ²Ð°ÑÑÐ¸ÑÑ',
    },
    {
      component: SelectCity,
      name: 'cityId',
      label: 'ÐÐ¾ÑÐ¾Ð´',
      rules: {
        required: true,
      },
    },
    // {
    //   label: 'ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ',
    //   name: 'company',
    //   placeholder: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸',
    // },
    // { component: SelectClientType, name: 'vip' },
  ]);

  const [contacts, setContacts] = useState([
    {
      name: 'email',
      label: 'E-mail',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð°Ð´ÑÐµÑ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    },
    {
      name: 'url',
      label: 'URL ÑÐ°Ð¹ÑÐ°',
      placeholder: 'Ð¡Ð°Ð¹Ñ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    },
    {
      component: SelectAddressType,
      name: 'addressType',
      defaultValue: { value: 1, label: 'ÐÐ¾Ð¼Ð°ÑÐ½Ð¸Ð¹' },
    },
    {
      name: 'address',
      label: 'ÐÐ´ÑÐµÑ',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð°Ð´ÑÐµÑ',
    },
    {
      name: 'addAddress',
      component: AddButton,
      text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°Ð´ÑÐµÑ',
      onClick: (e) => addFormInputs(e, 'addAddress', contacts, setContacts),

      style: { gridColumn: '1 / span 2' },
    },
  ]);
  const [documents, setDocuments] = useState([
    {
      component: SelectClientID,
      name: 'document_type_id',
      rules: {
        required: true,
      },
    },
    {
      name: 'document_number',
      label: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      rules: {
        required: true,
      },
    },
    {
      component: Datepicker,
      name: 'document_date',
      type: 'date',
      label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      defaultValue: null,
      rules: {
        required: true,
      },
    },
    {
      component: Datepicker,
      name: 'document_date_end',
      type: 'date',
      label: 'Ð¡ÑÐ¾Ðº Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      defaultValue: null,
      rules: {
        required: true,
      },
    },
    {
      component: SelectClientIssuer,
      name: 'document_issuer',
      label: 'ÐÐµÐ¼ Ð²ÑÐ´Ð°Ð½',
      rules: {
        required: true,
      },
    },
  ]);
  const [vu, setVu] = useState([
    {
      name: 'document_number',
      label: 'ÐÐ¾Ð¼ÐµÑ Ð²/Ñ',
    },
    {
      component: Datepicker,
      name: 'document_date',
      type: 'date',
      label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸',
    },
    {
      component: Datepicker,
      name: 'document_date_end',
      type: 'date',
      label: 'Ð¡ÑÐ¾Ðº Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ',
    },
  ]);

  const [comment, setComment] = useState([
    {
      name: 'comment',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐµ',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð»ÑÐ±ÑÐµ Ð·Ð°Ð¼ÐµÑÐºÐ¸ Ð¸Ð»Ð¸ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐµ',
    },
  ]);

  const addClient = async () => {
    setLoading(true);

    try {
      //TODO: refactor using HookForm
      const mainForm = {};
      for (let i = 0; i < mainData.length; i++) {
        if (mainData[i]?.rules?.required && !mainData[i]?.value) {
          throw new Error('ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð²ÑÐµ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐµ Ð¿Ð¾Ð»Ñ');
        }

        if (mainData[i].name === 'vip') {
          mainForm.vip = mainData[i].value?.value === 1 ? true : false;
        } else if (mainData[i].name === 'phoneNumber') {
          mainForm.phone = mainData[i].value.replace(/[^\d]/g, '');
        } else {
          mainForm[mainData[i].name] = mainData[i].value?.value ?? mainData[i].value;
        }
      }
      // ÐÐ¾Ð»Ñ Ð½Ð° ÑÐ¾ÑÐ¼Ðµ Ð½ÐµÑ, Ð° Ð±ÑÐºÑ languageId Ð½ÑÐ¶ÐµÐ½ ÑÐ¸ÑÐ»Ð¾Ð¼: Ð±ÐµÐ· Ð½ÐµÐ³Ð¾ ÑÐµÐ´ÐµÑ 0
      // Ð¸ ÐºÐ°ÑÑÐ¾ÑÐºÐ° ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¾ÐºÐ°Ð¶ÐµÑÑÑ Ð±ÐµÐ· ÑÐ·ÑÐºÐ°. ÐÐ¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ â ÑÑÑÑÐºÐ¸Ð¹.
      if (hideLanguage) {
        mainForm.languageId = 2;
      }
      for (let i = 0; i < documents.length; i++) {
        if (documents[i]?.rules?.required && !documents[i]?.value) {
          throw new Error('ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð²ÑÐµ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐµ Ð¿Ð¾Ð»Ñ');
        }
      }
      if(mainForm.iin?.replace(/\D/g, '').length != 12) {
        throw new Error('ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾ÑÑÑ ÐÐÐ');
      }

      try {
        const isPhoneBelongsToClient = await phoneBelongsIinValidate({
          phone: mainForm.phone,
          iin: mainForm.iin,
        });

        if (!isPhoneBelongsToClient) {
          throw new Error('ÐÐ»Ð¸ÐµÐ½Ñ Ñ ÑÑÐ¸Ð¼ ÐÐÐ Ð½Ðµ ÑÐ²Ð»ÑÐµÑÑÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐµÐ¼ Ð²Ð²ÐµÐ´ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð½Ð¾Ð¼ÐµÑÐ° ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð¸ Ð½Ðµ Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ ÐÐ°Ð·Ñ ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÑ ÐÑÐ°Ð¶Ð´Ð°Ð½. ÐÐ¾Ð¿ÑÐ¾ÑÐ¸ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð¸ÑÑ Ð´ÑÑÐ³Ð¾Ð¹ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°, Ð»Ð¸Ð±Ð¾ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶Ð¸ÑÐµ ÐµÐ¼Ñ Ð¿Ð¾Ð¼ÐµÐ½ÑÑÑ ÑÐ²Ð¾Ð¹ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð² ÐÐ°Ð·Ðµ ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÑ ÐÑÐ°Ð¶Ð´Ð°Ð½.');
        }
      } catch (e) {
        if (e.message?.includes('ÐÐ°Ð·Ñ ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÑ ÐÑÐ°Ð¶Ð´Ð°Ð½')) {
          throw e;
        }
        throw new Error(BMG_UNAVAILABLE_MESSAGE);
      }

      mainForm.name = mainForm.name?.trim();
      mainForm.surname = mainForm.surname?.trim();
      mainForm.middlename = mainForm.middlename?.trim();

      mainForm.name = toNameCase(mainForm.name);
      mainForm.surname = toNameCase(mainForm.surname);
      mainForm.middlename = toNameCase(mainForm.middlename);

      const addressesFilter = contacts.filter((item) => item.name.includes('address'));
      const mobileNumbersFilter = contacts.filter((item) => item.name.includes('phone'));
      const socialsFilter = contacts.filter((item) => item.name.includes('social'));
      const addresses = addValuesContactsForm(addressesFilter);
      const mobileNumbers = addValuesContactsForm(mobileNumbersFilter, true);
      const socials = addValuesContactsForm(socialsFilter);
      const contactsForm = {
        email: contacts[0]?.value,
        url: contacts[1]?.value,
        addresses,
        mobileNumbers,
        socials,
      };

      const commentForm = comment[0].value;
      const docs = {
        document_type_id: documents[0]?.value?.value,
        document_number: documents[1]?.value,
        document_date: documents[2]?.value,
        document_date_end: documents[3]?.value,
        document_issuer: documents[4]?.value?.value,
      };
      const docs_vu = {
        document_number: vu[0]?.value,
        document_date: vu[1]?.value,
        document_date_end: vu[2]?.value,
      };

      // return console.log({ mainForm, contactsForm, commentForm, documents: docs, driver_document: docs_vu })

      
      // const passClientValidation = user.options?.find((i) => i?.name === 'set_client')?.value;

      // if(passClientValidation !== true) {
        const isClientValid = await verifyClient({
          iin: mainForm.iin,
          phone: mainForm.phone,
          name: mainForm.name,
          surname: mainForm.surname,
          middlename: mainForm.middlename,
          born: dayjs(mainForm.born).format('YYYY-MM-DD'),
          document_number: docs.document_number,
          document_type_id: docs.document_type_id,
          document_date_end: dayjs(docs.document_date_end).format('YYYY-MM-DD'),
          document_date: dayjs(docs.document_date).format('YYYY-MM-DD'),
          document_issuer: docs.document_issuer,
        });
  
        if (isClientValid?.data !== true) {
          throw new Error('ÐÑÐ¸Ð±ÐºÐ° Ð²Ð°Ð»Ð¸Ð´Ð°ÑÐ¸Ð¸ Ð´Ð°Ð½Ð½ÑÑ');
        }
      // }

      const payload = new FormData();
      payload.append(
        'form',
        JSON.stringify({ mainForm, contactsForm, commentForm, document: docs, driver_document: docs_vu })
      );
      payload.append('photo', uploadPhoto);
      createClient(payload)
        .then(async (res) => {
          setSucces({ message: 'ÐÐ»Ð¸ÐµÐ½Ñ ÑÐ¾Ð·Ð´Ð°Ð½' });

          if (onCreated) {
            const created = res?.data;
            let clientId = created?.id ?? created?.clientId ?? created?.user?.id;
            if (!clientId) {
              // Ð±ÑÐº Ð½Ðµ Ð²ÐµÑÐ½ÑÐ» id â Ð´Ð¾Ð±Ð¸ÑÐ°ÐµÐ¼ Ð¿Ð¾ ÐÐÐ, ÑÑÐ¾Ð±Ñ Ð½Ðµ Ð²ÑÐºÐ¸Ð´ÑÐ²Ð°ÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð¸Ð· ÑÐ»Ð¾Ñ
              const found = await getClients({ iin: mainForm.iin }).catch(() => null);
              clientId = found?.data?.users?.[0]?.id;
            }
            onCreated(clientId);
            return;
          }

          if (window.history.length > 2) {
            historyObject.back();
          } else {
            navigate('/');
          }
        })
        .catch((error) => alert.error(error.response.data.errorMessage ?? JSON.stringify(error.response)))
        .finally(() => setLoading(false));
    } catch (e) {
      setLoading(false);
      if (e.response?.status === 400) {
        return alert.error(e?.response?.data?.errorMessage || 'ÐÑÐ¸Ð±ÐºÐ° Ð²Ð°Ð»Ð¸Ð´Ð°ÑÐ¸Ð¸ Ð´Ð°Ð½Ð½ÑÑ');
      }

      alert.error(e.message || 'ÐÑÐ¸Ð±ÐºÐ° Ð²Ð°Ð»Ð¸Ð´Ð°ÑÐ¸Ð¸ Ð´Ð°Ð½Ð½ÑÑ');
    }
  };

  const addValuesContactsForm = (array, isPhoneNumber) => {
    const result = [];
    for (let i = 0; i < array.length; i += 2) {
      if (array[i + 1].value) {
        result.push({
          type: array[i].value?.value ?? array[i].defaultValue?.value,
          value: isPhoneNumber ? array[i + 1].value.replace(/[^\d]/g, '') : array[i + 1].value,
        });
      }
    }
    return result;
  };

  return (
    <>
      {loading && <Loader />}
      <div className={styles.wrapper}>
        {!hidePhoto && <SelectPhoto photo={photo} setPhoto={setPhoto} setUploadPhoto={setUploadPhoto} />}
        <div className={styles.forms}>
          <HookForm
            title={'ÐÐ°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°'}
            grid={formStyles.mainData}
            border
            inputs={mainData}
            style={{ margin: 0 }}
            responsiveForm
          />
          {/* ÐÐ¾ÑÑÐ°, ÑÐ°Ð¹Ñ Ð¸ Ð°Ð´ÑÐµÑÐ° Ð½ÑÐ¶Ð½Ñ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð¼, Ð¾ÑÐºÑÐ´Ð° ÐºÐ»Ð¸ÐµÐ½ÑÑ ÑÑÐ¾Ð´ÑÑ Ð¿Ð¸ÑÑÐ¼Ð°.
              Ð¡ÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ Ð¸Ñ Ð½Ðµ ÑÐ»ÑÑ â Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð»Ð¸ÑÐ½Ð¸Ð¹ ÑÐºÑÐ°Ð½ Ð½Ð° ÐºÐ°Ð¶Ð´Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐµ. */}
          {!hideContacts && (
            <HookForm
              title={'ÐÐ¾Ð½ÑÐ°ÐºÑÐ½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ'}
              grid={formStyles.contacts}
              border
              inputs={contacts}
              style={{ margin: 0 }}
              responsiveForm
            />
          )}
          <HookForm
            title={'ÐÐ°Ð½Ð½ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²'}
            grid={formStyles.contacts}
            border
            inputs={documents}
            style={{ margin: 0 }}
            responsiveForm
          />
          {/* <HookForm title={'ÐÐ°Ð½Ð½ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²'} grid={formStyles.contacts} border inputs={vu} style={{ margin: 0 }} /> */}
          {/* <HookForm title={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾'} border grid={formStyles.comment} inputs={comment} style={{ margin: 0 }} /> */}
          <div>
            <Button text={'Ð¡Ð¾Ð·Ð´Ð°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°'} fill onClick={addClient} disabled={loading} />
          </div>
        </div>
      </div>
      {error.message && <Alert message={error.message} onClick={setError} />}
      {succes.message && <Alert message={succes.message} />}
    </>
  );
};

export default ClientCreate;

